<h2 class="step-title">{{ zipTitle }}</h2>
<p class="step-subtitle" *ngIf="notDebtSettlement">Get rates with no credit check required!</p>
<div class="field">
  <div [ngClass]="{'control': true,}">
    <input inputmode="numeric" class="input is-large border" type="text" placeholder="Zip Code" maxlength="5" formControlName="zipCode"
    [ngClass]="{'is-danger':highlightingBoxForRequiredInfo && controls[0].touched && controls[0].errors}"
    #zipCode (change)="zipChange($event)" name="zipCode" (input)="zipInput($event)" digitOnly>
  </div>

  <p class="help is-danger" *ngIf="controls[0].touched && controls[0].errors">Please enter a valid 5 digit US zip code.</p>
</div>

<div *ngIf="showAddressInput">

  <h2 class="step-title">{{ streetTitle }}</h2>

  <p [ngClass]="{'is-size-7 assurance': !removeAssuranceABTest, 'noAssurance': removeAssuranceABTest }">{{subtext}}</p>

  <div class="field">
    <div [ngClass]="{'control': true}">
      <input class="input is-large" type="text" placeholder="Street Address"
      [ngClass]="{'is-danger':highlightingBoxForRequiredInfo && controls[1].touched && controls[1].errors}"
      formControlName="streetAddress" #streetAddress (change)="snap()" name="streetAddress">
    </div>

    <p class="help is-danger" *ngIf="controls[1].touched && controls[1].errors">Please fill out your valid street
      address.</p>
  </div>

</div>

<!-- <div *ngIf="hideStreetAddress && controls[0].touched && !controls[0].errors">

  <h2 class="step-title">Street Address</h2>

  <p class="is-size-7 assurance">{{subtext}}</p>

  <div class="field">
    <div class="control">
      <input class="input is-large" type="text" placeholder="Street Address"
      [ngClass]="{'is-danger':highlightingBoxForRequiredInfo && controls[1].touched && controls[1].errors}"
        formControlName="streetAddress" #streetAddress (change)="snap()" name="streetAddress">
    </div>

    <p class="help is-danger" *ngIf="controls[1].touched && controls[1].errors">Please fill out your valid street
      address.</p>
  </div>

</div> -->

<button   class="button continue is-large has-shadow-small" (click)="submit()">
  Continue
<i class="fas fa-chevron-right"></i>
</button>
